var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSightcallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.289062 9.82669L0.325918 9.80298C8.87511 14.0098 20.31 14.9101 28.4613 9.85687C28.4613 9.85687 28.1569 6.83913 20.4335 4.15479C32.3837 4.02546 36.4153 9.63556 36.4153 9.63556C25.9728 18.1477 9.67979 18.0328 0.289062 9.82669Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1255 6.18423L36.0969 6.20722C27.5409 1.99389 16.1053 1.0936 7.95403 6.15405C7.95403 6.15405 8.25844 9.161 15.9811 11.8561C4.03708 11.9783 0 6.36745 0 6.36745C10.4486 -2.14471 26.7423 -2.03909 36.1255 6.18423Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightcallLogo);
export default __webpack_public_path__ + "static/media/sightcall-logo.968ade414c02329f7a397933b48320bb.svg";
export { ForwardRef as ReactComponent };